import { createSlice } from "@reduxjs/toolkit";
import {
  GET_WSS_CODE_SUCCESS,
  GET_WSS_CODE_FAIL,
  GET_TOWN_CODE_SUCCESS,
  GET_TOWN_CODE_FAIL,
  GET_BM_WSS_SUCCESS,
  GET_BM_WSS_FAIL,
  GET_RMDM_TOWN_SUCCESS,
  GET_RMDM_TOWN_FAIL,
} from "../constants/action-types";

// --- WSS Options Slice ---
const wssOptionsSlice = createSlice({
  name: "wssOptions",
  initialState: { wssCodeList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_WSS_CODE_SUCCESS, (state, { payload }) => {
        state.wssCodeList = payload;
      })
      .addCase(GET_WSS_CODE_FAIL, (state) => {
        state.wssCodeList = [];
      });
  },
});

// --- Town Options Slice ---
const townOptionsSlice = createSlice({
  name: "townOptions",
  initialState: { townCodeList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_TOWN_CODE_SUCCESS, (state, { payload }) => {
        state.townCodeList = payload;
      })
      .addCase(GET_TOWN_CODE_FAIL, (state) => {
        state.townCodeList = [];
      });
  },
});

// --- BM WSS Slice ---
const bmWssSlice = createSlice({
  name: "bmWss",
  initialState: { wssList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_BM_WSS_SUCCESS, (state, { payload }) => {
        state.wssList = payload;
      })
      .addCase(GET_BM_WSS_FAIL, (state) => {
        state.wssList = [];
      });
  },
});

// --- RMDM Town Slice ---
const rmdmTownSlice = createSlice({
  name: "rmdmTown",
  initialState: { townList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_RMDM_TOWN_SUCCESS, (state, { payload }) => {
        state.townList = payload;
      })
      .addCase(GET_RMDM_TOWN_FAIL, (state) => {
        state.townList = [];
      });
  },
});

export const wssOptionsReducer = wssOptionsSlice.reducer;
export const townOptionsReducer = townOptionsSlice.reducer;
export const bmWssReducer = bmWssSlice.reducer;
export const rmdmTownReducer = rmdmTownSlice.reducer;
